export const TABLE_HEADERS = [
  "No",
  "API Name",
  "Publisher",
  "Version",
  "Status",
  "Hosts",
  "Type Plan",
  "Category",
];
